import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import { LoginService } from './login.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
import * as i3 from "./login.service";
export class TrabajadorService {
    constructor(http, configService, loginService) {
        this.http = http;
        this.configService = configService;
        this.loginService = loginService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken')
            })
        };
        this.rolId = '';
        this.loginData = JSON.parse(sessionStorage.getItem('loginData'));
        this.rutContratista = this.loginData.usertableentity.empresa.rut;
    }
    ngOnInit() {
    }
    list(offset, quantity, roldId) {
        return this.http.get(`${this.configService.API_URL}/trabajadores?offset=${offset.toString(10)}&quantity=${quantity.toString(10)}
      &rolId=${roldId}&rutContratista=${this.rutContratista}`, this.jsonContent).toPromise();
    }
    listEmpresa(offset, quantity, planCapacitacion, rolId) {
        return this.http.get(`${this.configService.API_URL}/trabajadores/plan?offset=${offset.toString(10)}&quantity=${quantity.toString(10)}
      &rolId=${this.rolId}&planCapacitacion=${planCapacitacion}`, this.jsonContent).toPromise();
    }
    getTotalAmmount(rolId) {
        return this.http.get(`${this.configService.API_URL}/trabajadores/total?rolId=${rolId}
    &rutContratista=${this.rutContratista}`).toPromise();
    }
    getTotalAmmountEmpresa(planCapacitacion, rolId) {
        return this.http.get(`${this.configService.API_URL}/trabajadores/total-empresa?rolId=${rolId}
    &planCapacitacion=${planCapacitacion}`).toPromise();
    }
    searchContratista(rutContratista) {
        return this.http.get(`${this.configService.API_URL}/trabajadores/searchContratista?rutContratista=${rutContratista}`, this.jsonContent).toPromise();
    }
    search(rutTrabajador) {
        return this.http.get(`${this.configService.API_URL}/trabajadores/search?rutTrabajador=${rutTrabajador}`, this.jsonContent).toPromise();
    }
}
TrabajadorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TrabajadorService_Factory() { return new TrabajadorService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.LoginService)); }, token: TrabajadorService, providedIn: "root" });
